import React, { PureComponent, PropTypes } from 'react';

import LegendItem from './LegendItem';

class Legend extends PureComponent {

  render() {
    const mergedRanges = [];
    this.props.ranges.map((range) => {
      range.items.map((item, itemIndex) => {
        if (!mergedRanges[itemIndex]) {
          mergedRanges[itemIndex] = {
            text: item.text,
            ranges: [],
          };
        }
        mergedRanges[itemIndex].ranges.push({
          color: item.color,
          scale_icon: range.scale_icon,
          scale_label: range.scale_label,
          scale_key: itemIndex,
        });
        return true;
      });
      return true;
    });

    const legendItems = mergedRanges.map((item, index) =>
      <LegendItem key={`legend_item_${index}`} {...item} />);

    return (
      <div className={this.props.className}>{legendItems}</div>
    );
  }
}

Legend.defaultProps = {
  headline: '',
  ranges: [],
  className: 'mt-map-legend'
};

Legend.propTypes = {
  headline: PropTypes.string,
  ranges: PropTypes.array,
  className: PropTypes.string,
};

export default Legend;



/** WEBPACK FOOTER **
 ** ./apps/maptool/components/Legend/index.js
 **/